<template>
  <div
    v-if="!route.query?.print"
    class="mt-12 text-shade-50 bg-shade-900 md:mt-36"
  >
    <div class="mx-auto max-w-7xl">
      <div class="py-10 px-6">
        <div class="grid grid-cols-none gap-10 md:grid-cols-4">
          <MiscLogoIrcam
            :show-arrow="false"
            class="h-11 hover:text-primary-400"
          />
          <div>
            <h4 class="text-lg font-semibold first-letter:uppercase">IRCAM</h4>
            <p class="mt-2 text-shade-400">
              1, place Igor-Stravinsky <br />
              75004 Paris <br />
              +33 1 44 78 48 43
            </p>
          </div>
          <div>
            <h4 class="text-lg font-semibold first-letter:uppercase">
              {{ $t('footer.opening_times') }}
            </h4>
            <p class="mt-2 text-shade-400">
              {{ $t('footer.open_hours') }} <br />
              {{ $t('footer.closed_hours') }}
            </p>
          </div>
          <div>
            <h4 class="text-lg font-semibold first-letter:uppercase">
              {{ $t('footer.subway_access') }}
            </h4>
            <p class="mt-2 text-shade-400">
              Hôtel de Ville, Rambuteau, Châtelet, Les Halles
            </p>
          </div>
          <ul v-for="(group, i) in navigationLinks" :key="i">
            <li v-for="(link, j) in group" :key="j">
              <a
                :href="link.href"
                class="group flex gap-1 items-center font-semibold text-shade-50 hover:text-primary-400 transition-colors duration-200"
              >
                {{ $t(link.title) }}
                <ArrowRightIcon
                  class="mt-0.5 w-5 h-5 font-normal opacity-0 group-hover:opacity-100 transition-all duration-200 ease-out translate-x-0 group-hover:translate-x-2 stroke-0"
                />
              </a>
            </li>
          </ul>
          <ul>
            <li v-for="(link, i) in flatPages" :key="i">
              <a
                :href="`/flat${link.url}`"
                class="group flex gap-1 items-center italic underline font-semibold text-shade-50 hover:text-primary-400 transition-colors duration-200"
              >
                {{ $t(link.titleFr) }}
                <ArrowRightIcon
                  class="mt-0.5 w-5 h-5 font-normal opacity-0 group-hover:opacity-100 transition-all duration-200 ease-out translate-x-0 group-hover:translate-x-2 stroke-0"
                />
              </a>
            </li>
          </ul>
        </div>
        <div class="flex gap-4 justify-between items-center mt-10">
          <div class="flex gap-4 items-center">
            <LogoMinistere class="shrink-0 h-16" />
            <div>
              <p class="text-sm">
                Institut de Recherche et de Coordination Acoustique/Musique
              </p>
              <p class="text-sm text-shade-400">
                Copyright © 2022 Ircam. All rights reserved.
              </p>
            </div>
          </div>
          <MiscLangSwitcher
            v-slot="slotProps"
            :enable-mobile-mode="false"
            :dark="true"
          >
            <button
              class="inline-flex gap-1 justify-center items-center p-2 w-full font-semibold text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 bg-shade-alpha-50"
            >
              <span class="w-6 text-center">{{
                emojiFlag(slotProps.locale)
              }}</span>
              <span class="uppercase" v-text="slotProps.locale"></span>
              <NavigationChevronDown class="h-3" />
            </button>
          </MiscLangSwitcher>
        </div>
      </div>
    </div>
    <PatternHero :custom-pattern-height="3" color-class="text-shade-50" />
  </div>
</template>
<script lant="ts" setup>
import { useI18n } from '#i18n'
import LogoMinistere from '~/assets/logo/ministere_de_la_culture.svg'
import ArrowRightIcon from '~/assets/icon/navigation/Arrow/Right.svg'
import NavigationChevronDown from '~/assets/icon/navigation/Chevron/Down.svg'
import { getFlatPages } from '~/queries/flat'

// Locale
const { t } = useI18n()
const route = useRoute()
const emojiFlag = (locale) => {
  switch (locale) {
    case 'fr':
      return '🇫🇷'
    case 'en':
      return '🇬🇧'
    default:
      break
  }
}

const { data, pending, error } = await useAsyncData('flat pages', () =>
  execQuery(getFlatPages)
)

const flatPages = computed(() => {
  if (pending.value || error.value) return []
  return data.value.data.flats
})

// Footer navigation
const navigationLinks = [
  [
    {
      href: 'https://www.ircam.fr/job-offer',
      title: 'footer.job_offer',
    },
    {
      href: 'https://www.ircam.fr/lircam/lequipe-ircam/',
      title: 'footer.ircam_team',
    },
  ],
  [
    {
      href: 'https://www.ircam.fr/soutenez-lircam',
      title: 'footer.support_ircam',
    },
    {
      href: 'https://www.centrepompidou.fr/fr/',
      title: 'footer.centre_pompidou',
    },
  ],
]
</script>
